import { useEffect } from 'react';

interface IFreshChatWidgetProps {
	name?: string;
	id?: string;
	email?: string;
	validated?: boolean;
	phoneNumber?: string;
}

declare global {
	// tslint:disable-next-line
	interface Window {
		fcWidget: {
			init: (...args: any[]) => unknown,
			setExternalId: (id: string) => unknown,
			user: {
				setFirstName: (name: string) => unknown,
				setLastName: (name: string) => unknown,
				setEmail: (email: string) => unknown,
				setPhone: (phone?: string) => unknown;
			},
			isOpen: () => boolean,
			open: () => unknown,
			close: () => unknown;
		};
	}
}

export const FreshChatWidget: React.FC<IFreshChatWidgetProps> = ({
	name,
	id,
	email,
	phoneNumber,
}) => {
	const fcWidget = window.fcWidget;
	useEffect(() => {
		if (fcWidget) {
			const firstName = name ? name.split(' ')[0] : '';
			const lastName = name ? name.split(' ')[1] : '';

			console.log('Initialising FreshChat widget');
			fcWidget.init({
				token: 'c1ddea69-6846-4c71-8793-c1a9280a69e5',
				host: 'https://travelnest.freshchat.com',
				widgetUuid: 'a065873e-020f-44e8-8f65-7d3aba9e422d',
				config: {
					headerProperty: {
						hideChatButton: true,
					},
				},
				onLoad: () => {
					console.log('FreshChat widget loaded');
				},
			});
			fcWidget.setExternalId(id || '');
			fcWidget.user.setFirstName(firstName);
			fcWidget.user.setLastName(lastName);
			fcWidget.user.setEmail(email || '');
			fcWidget.user.setPhone(phoneNumber);
		}
	}, [id, name, email]);
	return null;
};

export const toggleFreshChatWidget = () => {
	const freshChatWidget = window.fcWidget;
	if (freshChatWidget) {
		if (freshChatWidget.isOpen()) {
			freshChatWidget.close();
		} else {
			freshChatWidget.open();
		}
	}
};
